.section {
  padding-block: clamp(56px, 8vw, 96px);
  background: var(--bg-page);
}

.panel {
  background: var(--color-blue-900);
  color: var(--text-on-dark);
  border-radius: var(--radius-lg);
  padding: clamp(40px, 7vw, 72px);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.panel h2 {
  margin-top: 10px;
  font-size: var(--step-4);
  text-transform: uppercase;
  color: var(--text-on-dark);
  max-width: 22ch;
}
.panel p {
  margin-top: 14px;
  font-size: 1.05rem;
  color: var(--text-on-dark-soft);
  max-width: 40ch;
}

.ctaRow {
  display: flex;
  gap: 14px;
  margin-top: 30px;
  flex-wrap: wrap;
  justify-content: center;
}

.location {
  margin-top: 24px;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: var(--color-blue-500);
}
